export default __webpack_public_path__ + "static/media/commentAction.d01edcd7.svg";